<template>
  <section class="vue-store" :class="mainClass">
    <div
      v-if="isSidebarActive"
      class="sidebar-overlay"
      :class="{ active: isSidebarActive }"
      @click.prevent="closeSidebar"
    ></div>

    <aside class="store-sidebar" :class="{ 'is-active': isSidebarActive }">
      <span 
      class="store-sidebar__close-btn"
      @click.prevent="closeSidebar"
      >
        {{ translations.closeFilter }}
        <i data-feather="x"></i>
      </span>

      <div class="store-sidebar__wrapper">
        <div class="store-sidebar__hamburger touch--only">
          <button
            class="store-hamburger hamburger"
            id="js-store-hamburger"
            aria-controls="js-store-hamburger"
            aria-expanded="false"
            type="button"
            burger-button
            :class="{ 'is-active': isBurgerActive }"
            @click.prevent="toggleBurger"
          >
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>

            <span class="open-filters">
              {{ translations.filterCategories }}
            </span>
          </button>

          <button
            class="store-hamburger"
            id="js-store-filters"
            aria-controls="js-store-filters"
            aria-expanded="false"
            type="button"
            burger-button
            :class="{ 'is-active': isFilterActive }"
            @click.prevent="toggleFilter"
          >
            <span class="hamburger-box">
              <i data-feather="filter"></i>
            </span>

            <span class="open-filters">
              {{ translations.filterProducts }}
            </span>
          </button>
        </div>

        <div v-touch:swipe.left="toggleBurger" v-touch:swipe.right="toggleBurger" class="store-sidebar__filters" :class="{ active: isBurgerActive }">
          <TaxToggle />

          <div class="filter filter--categories">
            <h2> {{ translations.categoryTitle }}</h2>

            <tree-view
              :categories="$store.state.categories"
              :title="translations.productCategories"
              :parent="0"
              :key="this.$store.state.filters.current.product_cat + ''"
            />
          </div>
          <Ad />
        </div>

        <div v-touch:swipe.left="toggleFilter" v-touch:swipe.right="toggleFilter" class="store-sidebar__filters touch--only" :class="{ active: isFilterActive }">
          <div class="filter">
            <h2> {{ translations.filterTitle }} </h2>

            <div class="filter-element"></div>

            <div class="store-sidebar__clear" v-if="hasActiveFilters" :class="{ active: isBurgerActive }">
              <button class="filters-clear" @click.prevent="removeFilters">
                {{ translations.emptyFilters }}
                <i data-feather="x"></i>
              </button>
            </div>

            <div class="filter filter--filters">
              <Filters :hasActiveFilters="hasActiveFilters" />
            </div>
          </div>
        </div>
      </div>
    </aside>

    <main>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </main>
  </section>
</template>

<script>
import TreeView from "@/components/archive/filters/hierarchical/TreeView.vue";
import Ad from "@/layouts/archive/ad/ad.vue";
import TaxToggle from "@/layouts/archive/sidebar/TaxToggle.vue";
import Filters from "@/layouts/archive/sidebar/Filters.vue";
import feather from 'feather-icons';

export default {
  name: "Home",
  components: {
    TreeView,
    Ad,
    TaxToggle,
    Filters
  },
  data() {
    return {
      offset: 50,
      isLoading: true,
      displaySlider: ws_vue_store.archive_price_slider == "1",
      isBurgerActive: false,
      isFilterActive: false,
      isSidebarActive: false,
      translations: {
        productCategories: ws_vue_store.translations.product_categories,
        emptyFilters: ws_vue_store.translations.empty_filters,
        sidebarFilters: ws_vue_store.translations.sidebar_filters,
        price: ws_vue_store.translations.price,
        filterProducts: ws_vue_store.translations.filter_products,
        filterCategories: ws_vue_store.translations.filter_categories,
        closeFilter: ws_vue_store.translations.close_filters,
        categoryTitle: ws_vue_store.translations.category_title,
        filterTitle: ws_vue_store.translations.filter_title
      },
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    hasActiveFilters() {
      if ( this.$store.getters.getActiveFiltersCount ) {
        return true;
      }
      return false;
    },
    displaySidebar() {
      if (this.$route.name === "Product") {
        return ws_vue_store.single_product_sidebar === "1";
      }
      return true;
    },
    displaySearch() {
      return ws_vue_store.use_vue_search === "1";
    },
    mainClass() {
      return {
        "vue-store--archive": true,
        "vue-store--single": this.$route.name === "Product",
        "vue-store--wishlist": this.$route.name === "Wishlist"
      };
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    closeSidebar() {
      this.isSidebarActive = false;
      this.isBurgerActive = false;
      this.isFilterActive = false;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 1024) {
        this.isSidebarActive = false;
      }
    },
    updatePriceMin(value) {
      this.$store.commit('changeProductsLoadingState', true);
      this.$store.commit('updatePriceFilter', { 'value': value, 'type': 'min' } );
    },
    updatePriceMax(value) {
      this.$store.commit('changeProductsLoadingState', true);
      this.$store.commit('updatePriceFilter', { 'value': value, 'type': 'max' } );
      this.$store.dispatch("getFilteredAttributes", []).then(() => this.$store.dispatch("getProducts", []));
    },
    toggleBurger() {
      if (!this.isBurgerActive) {
        this.isFilterActive = false;
      }
      this.isBurgerActive = !this.isBurgerActive;
      this.isSidebarActive = this.isBurgerActive || this.isFilterActive;
      feather.replace();
    },
    toggleFilter() {
      if (!this.isFilterActive) {
        this.isBurgerActive = false;
      }
      this.isFilterActive = !this.isFilterActive;
      this.isSidebarActive = this.isBurgerActive || this.isFilterActive;
      feather.replace();
    },
    removeFilters() {
      this.$store.commit('changeProductsLoadingState', true);
      this.$store.commit('clearFilters', {
        'ignoreCategory': ws_vue_store.empty_filters_ignore_category
      });
      this.$store.commit('updateUrlQuery');
      this.$store.commit('updateCategoryPath');
      this.$store.commit("isCurrentCategoryRent");
      this.$store.dispatch("getFilteredAttributes", []).then(() => this.$store.dispatch("getProducts", []));
    }
  },
  mounted() {
    feather.replace();
  },
  watch: {
    '$store.state.filters.current.product_cat'(newVal, oldVal) {
      if (newVal !== oldVal) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  }

};
</script>

<style scoped lang="scss">
@import "vue-select/src/scss/vue-select.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 8;
  display: none;
}

.sidebar-overlay.active {
  display: block;
}
</style>
